import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { inject } from '@angular/core';
import { setRedirectUrl } from '../../factory';
import { MsalAuthService } from '../../services/msal.service';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const jwtToken = tokenService.getToken();
  const router = inject(Router);
  const msalAuthService = inject(MsalAuthService);
  const resourceName = route.data['resourceName'];

  if (jwtToken && tokenService.hasPermission(resourceName)) {
    return true;
  }

  return msalAuthService.refreshTokensSilently().pipe(
    map((refreshed) => {
      if (refreshed && tokenService.getToken() && tokenService.hasPermission(resourceName)) {
        return true;
      }

      setRedirectUrl();
      router.navigateByUrl('/login');
      return false;
    }),
    catchError(() => {
      setRedirectUrl();
      router.navigateByUrl('/login');
      return of(false);
    })
  );
};
